<script>
import { Crud, SimpleUploader } from 'javaee-fre'
const AdminArticleEditor = () => import("./admin-article-editor.vue");

const selfCfg = {
    url: '/home/admin/c/article',
    titleField: 'title',
    listActions: [{
        label: '栏目管理', func() {
            this.$dialog.crud('栏目管理', { url: '/home/admin/c/column' });
        }
    }],
    listItemActions: [{
        label: '收藏', icon: 'favorite_border', func(cfg) {
            this.$favorite(5, cfg.item.id);
        }
    }, {
        label: '取消发布', icon: 'visibility_off', func(cfg) {
            let self = this;
            self.$axios.get(`/home/admin/c/article/status/${cfg.item.id}/${self.$dictVal(cfg.item.status) == 0 ? 1 : 0}`).then(r => {
                if (r.data && r.data.status == 'ok') {
                    self.$status('操作成功！', 'success');
                    self.refresh();
                    return;
                }
                self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
            });
        }
    }, {
        label: '编辑内容', icon: 'description', func(cfg) {
            let self = this;
            self.$dialog.component(cfg.item.title, AdminArticleEditor, {
                targetId: cfg.item.id,
                fullscreen: true,
                timestamp: Date.now()
            });
        }
    }, {
        label: '预览', icon: 'visibility', func(cfg) {
            let self = this;
            self.$dialog.component(`阅读预览 - ${cfg.item.title}`, "article-view", {
                id: cfg.item.id
            });
        }
    }, {
        label: '上传附件', icon: 'attachment', func(cfg) {
            let self = this;
            if (cfg.item.pdf) {
                self.$axios.post(`/home/admin/c/article/pdf/${cfg.item.id}`).then(() => {
                    self.refresh();
                    self.$status('删除附件成功～', 'success');
                });
            } else {
                self.$dialog.component(`上传附件 - ${cfg.item.title}`, SimpleUploader, {
                    width: 600, persist: true,
                    contentType: 'application/pdf',
                    url: `/home/admin/c/article/upload/pdf?__entity_id=${cfg.item.id}`,
                    onUploadSuccess(r, fn) {
                        if (r.data && r.data.success) {
                            self.$axios.post(`/home/admin/c/article/pdf/${cfg.item.id}`, self.$qs.stringify({ uuid: r.data.newUuid, fn: fn })).then(sr => {
                                if (sr.data && sr.data.status == 'ok') {
                                    self.$dialog.close();
                                    self.refresh();
                                    self.$status('上传附件成功～', 'success');
                                }
                            });
                        }
                    }
                });
            }
        }
    }, {
        label: '关联视频', icon: 'videocam', func(cfg) {
            let self = this;
            self.$dialog.crud(`从收藏中选择视频 - ${cfg.item.title}`, { url: '/home/my/favorite', params: { _type: 1 }, selectStyle: 'single' }, [{
                label: '确认添加', color: 'primary', func(sel) {
                    if (!sel) {
                        return;
                    }
                    let keys = Object.keys(sel);
                    if (keys.length < 1) {
                        return;
                    }
                    sel = sel[keys[0]];
                    self.$axios.get(`/home/admin/c/article/video/${cfg.item.id}/${sel.targetId}`).then(r => {
                        if (r.data && r.data.status == 'ok') {
                            self.$status('添加成功～', 'success');
                            self.refresh();
                        }
                    });
                }
            }]);
        }
    }, {
        label: '评论管理', icon: 'comment', func(cfg) {
            this.$router.push(`/console/home/admin/c/article/comment/${cfg.item.id}`, `评论管理 - ${cfg.item.title}`);
        }
    },
    {
        label: '阅读记录', icon: 'timeline', func(cfg) {
            this.$router.push(`/console/home/admin/c/article/log/${cfg.item.id}`, `阅读记录 - ${cfg.item.title}`);
        }
    },
    {
        label: '取消关联的视频', icon: 'videocam_off', confirm: '确认要取消已经关联的视频？', func(cfg) {
            let self = this;
            self.$axios.get(`/home/admin/c/article/video/${cfg.item.id}/0`).then(r => {
                if (r.data && r.data.status == 'ok') {
                    self.$status('取消成功～', 'success');
                    self.refresh();
                }
            });
        }
    },
    {
        label: '播放视频', icon: 'play_circle_outline', func(cfg) {
            let self = this;
            self.$axios.get(`/home/my/media/cc/url/${cfg.item.videoId}`).then(r => {
                if (r.data && r.data.status == 'ok' && r.data.message) {
                    self.$dialog.component(cfg.item.name, 'cc-video-viewer', { movieUrl: r.data.message });
                }
            });
        }
    },
    {
        label: '置顶', flag: 'top-up', icon: 'vertical_align_top', func(cfg) {
            let self = this;
            self.$axios.get(`/home/admin/c/article/top/${cfg.item.id}/1`).then(() => {
                self.refresh();
            });
        }
    },
    {
        label: '取消置顶', flag: 'top-down', icon: 'vertical_align_bottom', func(cfg) {
            let self = this;
            self.$axios.get(`/home/admin/c/article/top/${cfg.item.id}/0`).then(() => {
                self.refresh();
            });
        }
    }, {
        label: '刷新阅读量', icon: 'forward_5', func(cfg) {
            let self = this;
            self.$axios.get(`/home/admin/c/article/cal/rn/${cfg.item.id}`).then(() => { self.refresh(); });
        }
    }
    ],
    listItemFilter(i, acts) {
        if (this.$dictVal(i.status) == 0) {
            let act = acts.find(a => a.icon == "visibility_off");
            act.icon = "done";
            act.label = "发布";
        }
        if (i.videoId) {
            this.delAction(acts, "icon", "videocam");
        } else {
            this.delAction(acts, "icon", "videocam_off");
            this.delAction(acts, "icon", "play_circle_outline");
        }
        if (i.pdf) {
            let attachment = acts.find(a => a.icon == "attachment");
            attachment.label = '删除附件';
            attachment.icon = 'link_off';
            attachment.confirm = '确认要删除附件吗？';
        }

        if (!i.topTs) {
            this.delAction(acts, "flag", "top-down");
        }
        if (this.$store.state.account.tenantId == 0) {
            this.delAction(acts, "icon", "timeline");
        }
        return acts;
    }
}, topCfg = {
    url: '/home/admin/c/top/article',
    listItemActions: [
        {
            label: '预览', icon: 'visibility', func(cfg) {
                let self = this;
                self.$dialog.component(`阅读预览 - ${cfg.item.title}`, "article-view", {
                    id: cfg.item.id
                });
            }
        },
        {
            label: '阅读记录', icon: 'timeline', func(cfg) {
                this.$router.push(`/console/home/admin/c/article/log/${cfg.item.id}`, `阅读记录 - ${cfg.item.title}`);
            }
        }
    ]
};
export default {
    components: { Crud },
    data() {
        return {
            tabs: [
            ],
            active: 0,
            selfCfg: selfCfg,
            show: true
        };
    },
    methods: {
        init() {
            let self = this, a = self.$store.state.account, tabs = [];
            if (a.orgId) {
                tabs = [{ label: '自传材料', cfg: selfCfg }, { label: '下发材料', cfg: topCfg }];
            }
            self.tabs = tabs;
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        $route(n, o) {
            if (n.path.indexOf(o.path) == 0) {
                this.show = false;
            } else if (o.path.indexOf(n.path) == 0) {
                this.show = true;
            } else {
                this.init();
            }
        },
    }
}
</script>
<template>
    <v-container fluid class="px-0 py-0">
        <keep-alive>
            <div v-show="show">
                <v-tabs v-if="tabs && tabs.length > 0" v-model="active">
                    <v-tab v-for="tab in tabs" :key="tab.label">{{ tab.label }}</v-tab>
                    <v-tab-item v-for="tab in tabs" :key="tab.label">
                        <crud v-if="tab.cfg" :cfg="tab.cfg" />
                    </v-tab-item>
                </v-tabs>
                <crud v-else :cfg="selfCfg" />
            </div>
        </keep-alive>
        <router-view />
    </v-container>
</template>